export default function getEventQuantitySoldFromPage(page) {
  const quantitySoldForEvent = page.ticketGroups.reduce((prev, curr) => {
    const quantitySold = curr.ticketTypes.reduce((prev, curr) => {
      if (isNaN(curr.quantitySold)) {
        return prev;
      }
      return prev + curr.quantitySold;
    }, 0);
    return prev + quantitySold;
  }, 0);

  return quantitySoldForEvent;
}
